// Polyfill for packages that need global
window.global ||= window;

// Branding dari campus.config.json (warna utama untuk CSS var)
import campusConfig from 'src/config/campus'
if (typeof document !== 'undefined' && document.documentElement) {
  document.documentElement.style.setProperty('--campus-primary', campusConfig.primaryColor || '#1B5E20')
}

// Styles - use ES module imports
import 'src/styles/main.scss'
import 'react-image-lightbox/style.css'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'mobx-react'

import Routers from 'src/config/routers-new'
import AppState from 'src/stores/AppState'
import { create } from 'mobx-persist'
import { queryClient } from 'src/config/queryClient'

import { isProduction } from 'src/utils/Constants'
import { StoreProvider } from 'src/stores/useStore'

// Load amplitude for analytics - static import to ensure it's loaded before app renders
import 'src/config/amplitude'

const hydrate = create({
  storage: localStorage,
})

const appState = new AppState();

hydrate('obatukai', appState);

// React 18 createRoot API
const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <Provider store={appState}>
    <StoreProvider store={appState}>
      <QueryClientProvider client={queryClient}>
        <Routers />
      </QueryClientProvider>
    </StoreProvider>
  </Provider>
)
